import {
  icon_default
} from "./chunk-X2NXKQPU.js";

// src/blocks/icon/index.ts
var icon_default2 = icon_default;

export {
  icon_default2 as icon_default
};
